import React from 'react';
import {
  API_VARIANT_ISO,
  API_VARIANT_MOSIP,
  API_VARIANT_NIST,
  API_VARIANT_MINEX,
  API_VARIANT_RAW,
  API_VARIANT_HINTS,
  normalizeApiVariant,
} from '../biosdkRoutes';

const VARIANTS = [
  { value: API_VARIANT_MOSIP, label: 'MOSIP' },
  { value: API_VARIANT_ISO, label: 'ISO' },
  { value: API_VARIANT_RAW, label: 'Raw' },
  { value: API_VARIANT_NIST, label: 'NIST' },
  { value: API_VARIANT_MINEX, label: 'MINEX' },
];

export default function ApiVariantSelector({ value, onChange, compact = false }) {
  const selected = normalizeApiVariant(value);
  const hint = API_VARIANT_HINTS[selected] || '';

  return (
    <div className={`api-variant-selector${compact ? ' api-variant-selector--compact' : ''}`}>
      <div className="api-variant-selector-row">
        <span className="api-variant-label">API variant</span>
        <div className="api-variant-segments" role="group" aria-label="API variant">
          {VARIANTS.map(({ value: variantValue, label }) => (
            <button
              key={variantValue}
              type="button"
              className={`api-variant-segment${selected === variantValue ? ' active' : ''}`}
              aria-pressed={selected === variantValue}
              onClick={() => onChange(variantValue)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      {hint && <p className="api-variant-hint">{hint}</p>}
    </div>
  );
}
